import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgHigher = (props, ref) => (_jsx("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M8.47622 0.872452L1.8183 7.51849L3.80973 9.48614L7.06736 6.21663L7.0695 15.1275H9.95642V6.21663L13.2319 9.48614L15.1817 7.51849L8.53567 0.872452H8.47622Z", fill: "currentColor" }) }));
const ForwardRef = forwardRef(SvgHigher);
export default ForwardRef;
